import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'ostests',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: 'osTests',
    method: 'get',
    params: queriesParams
  })
}

export function fetchVehicleData(queriesParams) {
  return request({
    url: `vehicledata?`,
    method: 'get',
    params: queriesParams
  })
}


export function fetchVehiclePosition(vehicle) {
  return request({
    url: `vehicle-position/${vehicle}`,
    method: 'get'
  })
}

export function fetchVerifySerial(serial) {
  return request({
    url: `verify-serial/${serial}`,
    method: 'get'
  })
}

export function fetchVerifyBoard(board) {
  return request({
    url: `verify-board/${board}`,
    method: 'get'
  })
}

export function fetchSendCommand(data) {
  return request({
    method: 'post',
    url: `send-command`,
    data
  })
}

export function fetchConfirmCommand(data) {
  return request({
    url: 'verify-confirm-command',
    method: 'post',
    data
  })
}

export function fetchCommandHistoric(params) {
  return request({
    url: 'command-historic',
    method: 'get',
    params
  })
}

export function fetchFinishedTest(data) {
  return request({
    url: `ostest-finish/${data.id}`,
    method: 'post',
    data
  })
}

export function addOsTests (osTests) {
  return request({
    method: 'post',
    url: 'osTests',
    data: osTests
  })
}

export function show (id) {
  return request({
    url: `osTests/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `osTests/${id}`,
    method: 'patch',
    data
  })
}

export function equipmentData(serial) {
  return request({
    url: 'equipmentdata',
    method: 'get',
    params: serial
  })
}

export function fetchAllSerials () {
  return request({
    url: 'serials',
    method: 'get'
  })
}

export function fetchExchangeSerial (data) {
  return request({
    url: `exchange-serial/${data.id}`,
    method: 'patch',
    data
  })
}

export function cancelCommand (data) {
  return request({
    url: `ostests/${data.vehicleId}`,
    method: 'patch',
    data
  })
}

export function saveOsLog(data) {
  return request({
    url: 'save-os-log',
    method: 'post',
    data
  })
}